




























import { Component, Vue } from 'vue-property-decorator';
import CartSummary from '../components/shared/CartSummary.vue';

@Component({
  components: {
    CartSummary
  },
})
export default class Cart extends Vue {
  cartItems = [];
  totalPrice = 0;


  handleQuantity(item, value) {
    value = item.quantity;
    this.$store.dispatch('updateItemQuantity', [item, value]);
  }

  removeItem(item) {
    this.$store.dispatch('removeItemFromCart', item);
  }

  created() {
    this.cartItems = this.$store.state.cartItems;
    this.totalPrice = this.$store.getters.getTotalPrice;
  }
}

